import template from './service-list.html';
import controller from './service-list.controller';

let serviceListComponent = {
  bindings: {},
  template,
  controller
};

export default serviceListComponent;



// WEBPACK FOOTER //
// ./client/app/components/service/service-list.component.js